import React from "react";
import Button from "@material-ui/core/Button";
import { useSelector } from "react-redux";

export default function NotAvailable({ type_of_product }) {
  const language = useSelector((state) => state.store.language);
  const customTexts = useSelector(
    (state) => state.store.store.settings.custom_texts
  );

  const text = language === "arabic" ? customTexts.not_available_ar : customTexts.not_available;
  return (
    <Button
      className="mx-auto"
      variant="outlined"
      disableRipple
      disableElevation
      size={"small"}
      style={{
        color: "#919191",
        fontWeight: "bold",
        border: "1px solid",
        direction: language === "arabic" && "ltr",
        textTransform: "none",
        fontSize: 14,
        height: 30,
        width: "100%",
      }}
    >
      <span>{text}</span>
    </Button>
  );
}
